import { Circle, Path, Svg } from '@react-pdf/renderer';
const PdfSiInformation = () => (
  <Svg width="50" height="50" viewBox="0 0 24 24">
    <Path stroke="currentColor" strokeLinejoin="round" strokeWidth={2} d="M12 13V15" />
    <Circle cx={12} cy={9} r={1} fill="currentColor" />
    <Circle cx={12} cy={12} r={7.25} stroke="currentColor" strokeLinejoin="round" strokeWidth={2} />
  </Svg>
);
export default PdfSiInformation;
